import { STATUS_TYPE_DEUDOR } from 'src/app/entities/income-order/constants';

export type DeudorTipo = (typeof STATUS_TYPE_DEUDOR)[keyof typeof STATUS_TYPE_DEUDOR];

/**
 * Modelo de Orden de Ingreso
 */
export interface Deudor {
  id: string;
  nombre: string;
  tipo: DeudorTipo;
}

export interface Multimedia {
  id: string;
  fileName: string;
}

export interface AccountStatement {
  id: string;
  period: string;
  clientId: string;
  clientName: string;
  createdAt: string;
  updatedAt: string;
  startDate: string;
  endDate: string;
  dueDate: string;
}

export interface OrdenIngreso {
  id: string;
  numberOI?: number | string;
  estado: 'CREADA' | 'RECIBIDA' | 'PROCESADA' | 'RECHAZADA';
  fechaCreacion: string;
  fechaRecepcion?: string;
  observacion?: string;
  tipoIngreso: string;
  categoriaIngreso: string;
  subcategoriaIngreso: string;
  moneda: 'PEN' | 'USD';
  monto: number;
  deudor: Deudor;
  listMultimedia?: Multimedia[];
  accountStatement?: AccountStatement;
  createdAt?: string;
  updatedAt?: string;
  invoiceRelacionadas?: number; // Suma de montos de invoices relacionadas
}

export interface OrdenIngresoInput {
  estado?: string;
  observacion?: string;
  tipoIngreso: string;
  categoriaIngreso: string;
  subcategoriaIngreso: string;
  moneda: 'PEN' | 'USD';
  monto: number;
  deudorId: string;
}
